module.exports = __webpack_public_path__ + "img/ES3081.ac535b30.png";